// extracted by mini-css-extract-plugin
export default {"wrapper":"o601IKL"};